import { Experience } from '../types';

export const experiences: Experience[] = [
  {
    id: 'rmg',
    company: 'RMG',
    location: 'الرياض، المملكة العربية السعودية',
    role: 'مهندس ذكاء اصطناعي أول',
    previousRole: 'مطور تطبيقات موبايل أول',
    startDate: '[تاريخ البداية]',
    endDate: 'حتى الآن',
    isCurrent: true,
    project: 'Private AI Platform & MyUB — جامعة بيشة',
    roleTransition: {
      from: 'مهندس موبايل أول',
      to: 'مهندس ذكاء اصطناعي أول',
    },
    description: [
      'قيادة هندسة منصة ذكاء اصطناعي خاصة (On-Premise) لجامعة بيشة على بنية GPU الجامعة، مع تطبيق MyUB للخدمات الجامعية.',
      'المنصة تدعم خدمات المستفيدين ومتطلبات قياس التحول الرقمي (هيئة الحكومة الرقمية — التقنيات الناشئة).',
    ],
    highlights: [
      'منصة AI خاصة: LLM على GPU، Docker، n8n، NestJS + React',
      'شات بوت ولوحة إدارة AI دون الاعتماد على APIs خارجية',
      'دعم التحول الرقمي — خدمات المستفيدين بالتقنيات الناشئة',
      'مطور موبايل أول: تطبيق MyUB وخدمات الجامعة',
    ],
    technologies: [
      'LLM',
      'Docker',
      'n8n',
      'NestJS',
      'React',
      'React Native',
      'RAG',
      'Linux',
      'REST APIs',
    ],
    companyLogo: '/images/companies/rmg.png',
  },
  {
    id: 'joacademy',
    company: 'JoAcademy',
    location: 'الأردن',
    role: 'مطور تطبيقات موبايل أول',
    startDate: '[تاريخ البداية]',
    endDate: '[تاريخ النهاية]',
    isCurrent: false,
    project: 'JoAcademy',
    description: [
      'خطوة مهمة نحو الهندسة المتقدمة وأمان التطبيقات على منصة تعليمية للطلاب والمحتوى التعليمي.',
    ],
    highlights: [
      'تطوير React Native وReact متقدم',
      'هندسة الموبايل وأمان التطبيقات',
      'حماية المحتوى التعليمي من الوصول غير المصرح',
      'إدارة وصيانة طبقة أمان التطبيق',
    ],
    technologies: ['React Native', 'React', 'أمان الموبايل', 'Firebase'],
    companyLogo: '/images/companies/joAcademy.png',
  },
  {
    id: 'deloitte',
    company: 'Deloitte',
    location: 'الأردن (Outsource)',
    role: 'مستشار تطبيقات موبايل',
    startDate: '[تاريخ البداية]',
    endDate: '[تاريخ النهاية]',
    isCurrent: false,
    project: 'بنك الإنماء',
    description: [
      'خبرة مؤسسية ومصرفية مهمة ضمن ممارسات هندسة البرمجيات الاحترافية.',
    ],
    highlights: [
      'استشارات تطبيقات موبايل للقطاع المصرفي المؤسسي',
      'متطلبات تطبيقات واسعة النطاق',
      'ممارسات هندسة برمجيات احترافية',
    ],
    technologies: ['تطوير الموبايل', 'تطبيقات مؤسسية'],
    companyLogo: '/images/companies/deloitte.png',
  },
  {
    id: 'digitalcash',
    company: 'Digital Cash',
    location: 'الأردن',
    role: 'مطور تطبيقات موبايل',
    startDate: '[تاريخ البداية]',
    endDate: '[تاريخ النهاية]',
    isCurrent: false,
    description: [
      'بناء تطبيقات أعمال حقيقية لحجز الصالونات وإدارة مزودي المبيعات.',
    ],
    highlights: [
      'تطبيق الصالون — اكتشاف الصالونات، حجز وإدارة المواعيد، التفاعل مع خدمات الصالون',
      'تطبيق مزود المبيعات — تطبيق أعمال لعمليات المبيعات',
    ],
    technologies: ['React Native', 'تطوير الموبايل'],
    companyLogo: '/images/companies/digitalcash.png',
    companyUrl: 'https://dg-cash.com/',
  },
  {
    id: 'opensooq',
    company: 'Open Sooq',
    location: 'الأردن',
    role: 'مطور خلفية PHP / Yii2',
    startDate: '[تاريخ البداية]',
    endDate: '[تاريخ النهاية]',
    isCurrent: false,
    project: 'OpenSooq — السوق المفتوح',
    description: [
      'عززت أسس الخلفية وتطوير الويب من خلال أنظمة مؤسسية داخلية.',
    ],
    highlights: [
      'تطوير خلفية PHP بإطار Yii2',
      'أنظمة مبيعات داخلية وواجهات API',
      'منطق الأعمال ووظائف لوحة التحكم/الخلفية',
    ],
    technologies: ['PHP', 'Yii2', 'REST APIs', 'MySQL'],
    companyLogo: '/images/companies/opensooq.png',
    companyUrl: 'https://jo.opensooq.com/ar',
  },
  {
    id: 'beecell',
    company: 'BEECell',
    location: 'الأردن',
    role: 'مهندس Java / مطور تطبيقات React Native',
    startDate: '[تاريخ البداية]',
    endDate: '[تاريخ النهاية]',
    isCurrent: false,
    project: 'Soalk',
    description: [
      'مرحلة مبكرة في مسيرتي حيث انتقلت من Java إلى تطوير الموبايل الحديث.',
      'عملت على تطبيق التواصل الاجتماعي Soalk، المركز على الأسئلة والتفاعل الاجتماعي.',
    ],
    highlights: [
      'تطوير Java',
      'تطوير تطبيقات React Native',
      'دعم أنواع المحتوى: فيديوهات قصيرة، صوت، صور، ونص',
      'تنفيذ سلوكيات اجتماعية: متابعة، إعجاب، مشاركة، والتفاعل مع المحتوى',
    ],
    technologies: ['Java', 'React Native', 'تطوير الموبايل'],
    companyLogo: '/images/companies/beecell2.png',
    companyUrl: 'https://play.google.com/store/apps/details?id=com.beecell.so2alak',
  },
];
